/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialInFormulaDto
 */
export interface MaterialInFormulaDto {
    /**
     * Material external ID (idnumber from Personalized Nutrients)
     * @type {string}
     * @memberof MaterialInFormulaDto
     */
    externalId: string;
    /**
     * Material name
     * @type {string}
     * @memberof MaterialInFormulaDto
     */
    name: string;
    /**
     * Active component of the material
     * @type {string}
     * @memberof MaterialInFormulaDto
     */
    activeComponent: string;
    /**
     * Weight/dosage of the material in the formula
     * @type {number}
     * @memberof MaterialInFormulaDto
     */
    weight: number;
    /**
     * Unit of measurement (mcg, IU, mg)
     * @type {object}
     * @memberof MaterialInFormulaDto
     */
    unit: object | null;
}

/**
 * Check if a given object implements the MaterialInFormulaDto interface.
 */
export function instanceOfMaterialInFormulaDto(value: object): value is MaterialInFormulaDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('activeComponent' in value) || value['activeComponent'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function MaterialInFormulaDtoFromJSON(json: any): MaterialInFormulaDto {
    return MaterialInFormulaDtoFromJSONTyped(json, false);
}

export function MaterialInFormulaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialInFormulaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'name': json['name'],
        'activeComponent': json['activeComponent'],
        'weight': json['weight'],
        'unit': json['unit'],
    };
}

export function MaterialInFormulaDtoToJSON(json: any): MaterialInFormulaDto {
    return MaterialInFormulaDtoToJSONTyped(json, false);
}

export function MaterialInFormulaDtoToJSONTyped(value?: MaterialInFormulaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'name': value['name'],
        'activeComponent': value['activeComponent'],
        'weight': value['weight'],
        'unit': value['unit'],
    };
}

